<template>
<div>
  <span v-if="row.speedControl === 'DOUBLE_SPEED'">
    <span :class="row[highKey] < 0 ? 'ft-red' : 'ft-green'">{{formatValue(row[highKey])}}</span>
    /
    <span :class="row[lowKey] < 0 ? 'ft-red' : 'ft-green'">{{formatValue(row[lowKey])}}</span>
  </span>
  <span v-else>
    <span :class="row[singleKey] < 0 ? 'ft-red' : 'ft-green'">{{formatValue(row[singleKey])}}</span>
  </span>
</div>
</template>

<script>
export default {
  name: 'DeviationValue',
  props: {
    row: {
      type: Object,
      required: true
    },
    relateProp: String,
  },
  computed: {
    singleKey() { return `${this.relateProp}DeviationRate` },
    highKey() { return `${this.relateProp}HighDeviationRate` },
    lowKey() { return `${this.relateProp}LowDeviationRate` },
  },
  methods: {
    formatValue(val) {
      return val > 0 ? `+${val}` : val === null ? '-' : val
    }
  }
}
</script>

<style scoped>

</style>
